<h1 class="text--base text--medium m-4">{{ props.title }}</h1>
<div class="px-5 pb-5">
  <audio
    *ngIf="!unplayable"
    class="player"
    controls
    autoplay
    [src]="props.url"
    (error)="onError($event)"
    [attr.aria-label]="
      'COMPONENTS.MEDIA.PLAY_AUDIO' | translate: { title: props.title }
    "
    data-cy="audio-modal-player"
  ></audio>
  <div
    *ngIf="unplayable"
    class="status"
    data-cy="audio-modal-unplayable"
  >
    <span>{{ "COMPONENTS.MEDIA.UNPLAYABLE" | translate }}</span>
    <ion-button
      fill="outline"
      [href]="props.url"
      target="_blank"
    >
      {{ "COMMON.LABELS.DOWNLOAD" | translate }}
    </ion-button>
  </div>
  <ion-button
    class="mt-3"
    expand="block"
    fill="clear"
    (click)="dismiss()"
    data-cy="audio-modal-close"
  >
    {{ "COMMON.LABELS.CLOSE" | translate }}
  </ion-button>
</div>
